import { z } from 'zod'

export const createPortfolioSchema = z.object({
  title: z
    .string()
    .min(1, { message: 'Nome é obrigatório' })
    .max(40, { message: 'Nome deve ter no máximo 40 caracteres' }),
  description: z.string().optional(),
})

export type CreatePortfolioSchema = z.infer<typeof createPortfolioSchema>
